// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__MfvTw","container":"MainPage_container__Lp1Wf"};